<template>
  <div class="bill-exchange-product">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <i class="fas fa-exchange-alt text-primary mr-2"></i>
        <div>
          <span class="section-title">Danh sách sản phẩm xuất đổi</span>
          <div class="text-muted small">
            {{ rows.length }} cặp đổi · SP cũ và SP mới phải cùng loại
          </div>
        </div>
      </div>
      <b-button
        variant="light"
        size="sm"
        class="font-weight-bold add-btn"
        :disabled="!availableOldItems.length"
        @click="$emit('add')"
      >
        <i class="fas fa-plus mr-1" style="font-size: 0.75rem"></i> Thêm sản phẩm
      </b-button>
    </div>

    <!-- Column labels -->
    <b-row class="col-head m-0" v-if="rows.length">
      <b-col md="6" class="px-0">
        <span class="dot dot-old"></span> SẢN PHẨM CŨ (THU VỀ)
      </b-col>
      <b-col md="6" class="px-0 text-md-left">
        <span class="dot dot-new"></span> SẢN PHẨM MỚI (GIAO KHÁCH)
      </b-col>
    </b-row>

    <!-- Pairs -->
    <div
      v-for="(row, index) in rows"
      :key="row.id"
      class="pair-card"
      :class="{ invalid: !!statusOf(row) }"
    >
      <div class="pair-head">
        <span class="index-badge">{{ index + 1 }}</span>
        <b-badge class="type-badge" :variant="isImei(row) ? 'info' : 'secondary'">
          <i :class="isImei(row) ? 'fas fa-hashtag' : 'fas fa-box'"></i>
          {{ isImei(row) ? 'SP IMEI' : 'SP thường' }}
        </b-badge>
        <b-badge v-if="statusOf(row)" variant="warning" class="status-badge">
          <i class="fas fa-exclamation-triangle"></i> {{ statusOf(row) }}
        </b-badge>
        <span class="flex-grow-1"></span>
        <i
          class="fas fa-trash-alt text-muted delete-icon"
          @click="$emit('remove', row.id)"
          v-b-tooltip
          title="Xóa cặp đổi"
        ></i>
      </div>

      <div class="pair-body">
        <!-- OLD product -->
        <div class="prod-card prod-old">
          <!-- chọn SP cũ (cho dòng thêm mới) -->
          <div v-if="!row.productId">
            <b-form-select
              class="select-style"
              size="sm"
              :value="null"
              :options="oldItemOptions"
              @change="onSelectOldItem($event, row)"
            ></b-form-select>
          </div>
          <template v-else>
            <div class="prod-info">
              <ProductImage :src="row.imageUrl" />
              <div class="prod-text">
                <span class="prod-code">{{ row.productCode }}</span>
                <span class="prod-bar">({{ row.barCode }})</span>
                <p class="prod-name">{{ row.productName }}</p>
                <b-badge
                  v-if="isImei(row) && row.imeiCode"
                  variant="light"
                  class="imei-tag"
                >
                  <i class="fas fa-hashtag"></i> {{ row.imeiCode }}
                </b-badge>
              </div>
            </div>
            <div class="prod-inputs">
              <div class="input-block">
                <label>SL THU VỀ</label>
                <b-form-input
                  size="sm"
                  type="number"
                  min="1"
                  :disabled="isImei(row)"
                  v-model.number="row.oldQuantity"
                  @input="onOldQuantityChange(row)"
                ></b-form-input>
              </div>
              <div class="input-block">
                <label>GIÁ GỐC</label>
                <b-form-input
                  size="sm"
                  class="text-right"
                  v-model="row.productPrice"
                  v-mask="mask"
                  :disabled="lockPrices"
                ></b-form-input>
              </div>
            </div>
          </template>
        </div>

        <!-- arrow -->
        <div class="pair-arrow">
          <i class="fas fa-arrow-right"></i>
        </div>

        <!-- NEW product -->
        <div class="prod-card prod-new">
          <template v-if="row.newProductId">
            <div class="prod-info">
              <ProductImage :src="row.newImageUrl" />
              <div class="prod-text">
                <span class="prod-code">{{ row.newProductCode }}</span>
                <span class="prod-bar">({{ row.newBarCode }})</span>
                <p class="prod-name">{{ row.newProductName }}</p>
              </div>
              <i
                class="fas fa-times-circle text-muted reset-new"
                @click="resetNewProduct(row)"
                v-b-tooltip
                title="Chọn lại sản phẩm mới"
              ></i>
            </div>

            <!-- IMEI new -->
            <div v-if="isImei(row)" class="prod-inputs">
              <div class="input-block flex-grow-1">
                <label>IMEI MỚI</label>
                <b-button
                  block
                  size="sm"
                  class="choose-imei-btn"
                  :class="{ chosen: row.newImeiCode }"
                  @click="openImeiModal(row)"
                >
                  <i class="fas fa-hashtag mr-1"></i>
                  {{ row.newImeiCode ? row.newImeiCode : 'Chọn IMEI mới' }}
                </b-button>
              </div>
              <div class="input-block">
                <label>GIÁ MỚI</label>
                <b-form-input
                  size="sm"
                  class="text-right"
                  v-model="row.newProductPrice"
                  v-mask="mask"
                  :disabled="lockPrices"
                ></b-form-input>
              </div>
            </div>
            <!-- normal new -->
            <div v-else class="prod-inputs">
              <div class="input-block">
                <label>SL MỚI</label>
                <b-form-input
                  size="sm"
                  type="number"
                  min="1"
                  class="text-right"
                  v-model.number="row.newQuantity"
                ></b-form-input>
              </div>
              <div class="input-block">
                <label>GIÁ MỚI</label>
                <b-form-input
                  size="sm"
                  class="text-right"
                  v-model="row.newProductPrice"
                  v-mask="mask"
                  :disabled="lockPrices"
                ></b-form-input>
              </div>
            </div>
          </template>

          <!-- chưa chọn SP mới -->
          <template v-else>
            <BillSaleProductSearchSelect
              :store-id="newStoreId"
              :bill-type="billType"
              :disabled="!newStoreId || !row.productId"
              compact
              @select="onSelectNewProduct($event, row)"
            />
            <div
              v-if="row.productId"
              class="quick-pick"
              @click="pickSameAsOld(row)"
            >
              <i class="fas fa-plus mr-1"></i> Chọn nhanh cùng SP cũ
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-if="!rows.length" class="empty-box">
      Chưa có cặp sản phẩm nào. Nhấn "Thêm sản phẩm" để bắt đầu.
    </div>

    <ExchangeImeiModal ref="imeiModal" v-on:selected="onImeiSelected" />
  </div>
</template>

<script>
import { PRODUCT_TYPE, BILL_TYPE } from '@/utils/enum';
import { currencyMask, makeToastFaile } from '@/utils/common';
import ProductImage from '@/view/components/products/ProductImage.vue';
import ExchangeImeiModal from '@/view/components/bills/ExchangeImeiModal.vue';
import BillSaleProductSearchSelect from '@/view/components/bills/BillSaleProductSearchSelect.vue';

export default {
  components: {
    ProductImage,
    ExchangeImeiModal,
    BillSaleProductSearchSelect,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    newStoreId: {
      type: Number,
      default: null,
    },
    billType: {
      type: Number,
      default: BILL_TYPE.RETAIL_INVOICE,
    },
    // các sản phẩm chính của hóa đơn gốc (để thêm cặp đổi mới)
    originalItems: {
      type: Array,
      default: () => [],
    },
    lockPrices: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mask: currencyMask,
    };
  },
  computed: {
    usedOldKeys() {
      return this.rows
        .filter((row) => row.productId)
        .map((row) => this.itemKey(row));
    },
    availableOldItems() {
      return this.originalItems.filter(
        (item) => !this.usedOldKeys.includes(this.itemKey(item)),
      );
    },
    oldItemOptions() {
      const options = [{ value: null, text: 'Chọn sản phẩm cũ từ hóa đơn gốc' }];
      this.availableOldItems.forEach((item) => {
        const imeiLabel = item.imeiCode ? ` - IMEI: ${item.imeiCode}` : '';
        options.push({
          value: this.originalItems.indexOf(item),
          text: `${item.productName}${imeiLabel}`,
        });
      });
      return options;
    },
  },
  methods: {
    itemKey(item) {
      return `${item.productId}__${item.imeiCode || ''}`;
    },
    isImei(row) {
      return row.productType === PRODUCT_TYPE.PRODUCT_IMEI;
    },
    statusOf(row) {
      if (!row.productId) {
        return 'Chưa chọn SP cũ';
      }
      if (!row.newProductId) {
        return 'Chưa chọn SP mới';
      }
      if (this.isImei(row) && !row.newImeiCode) {
        return 'Thiếu IMEI mới';
      }
      if (!this.isImei(row) && (!row.newQuantity || row.newQuantity < 1)) {
        return 'SL mới không hợp lệ';
      }
      return null;
    },
    onOldQuantityChange(row) {
      if (!this.isImei(row) && (!row.newQuantity || row.newQuantity < 1)) {
        row.newQuantity = row.oldQuantity;
      }
    },
    onSelectOldItem(originalIndex, row) {
      if (originalIndex === null || originalIndex === undefined) {
        return;
      }
      const item = this.originalItems[originalIndex];
      if (!item) {
        return;
      }
      row.productId = item.productId;
      row.productName = item.productName;
      row.productCode = item.productCode;
      row.barCode = item.barCode;
      row.imageUrl = item.imageUrl;
      row.imeiCode = item.imeiCode || '';
      row.productType = item.productType;
      row.oldQuantity = item.quantity || 1;
      row.productPrice = item.productPrice || 0;
      row.newQuantity = item.quantity || 1;
      row.newProductPrice = item.productPrice || 0;
    },
    applyNewProduct(row, item) {
      if (
        row.productType &&
        item.productType &&
        row.productType !== item.productType
      ) {
        makeToastFaile(
          `Sản phẩm cũ và sản phẩm mới (${row.productName}) phải cùng loại sản phẩm!`,
        );
        return;
      }
      row.newProductId = item.productId;
      row.newProductName = item.productName;
      row.newProductCode = item.productCode;
      row.newBarCode = item.barCode;
      row.newImageUrl = item.imageUrl || item.productImageUrl || '';
      row.newSearchText = item.productName;
      row.newProductPrice =
        item.sellingPriceMask != null
          ? item.sellingPriceMask
          : item.sellingPrice != null
            ? item.sellingPrice
            : row.productPrice || 0;
      row.newProductType = row.productType;
      row.newImeiCode = '';
      if (this.isImei(row)) {
        const imeiCode = item.imeiCode ? String(item.imeiCode).trim() : '';
        if (imeiCode) {
          row.newImeiCode = imeiCode;
        }
        row.newQuantity = 1;
      } else {
        row.newQuantity = row.oldQuantity || 1;
      }
    },
    onSelectNewProduct(node, row) {
      if (!node) {
        return;
      }
      this.applyNewProduct(row, node);
    },
    pickSameAsOld(row) {
      this.applyNewProduct(row, {
        productId: row.productId,
        productName: row.productName,
        productCode: row.productCode,
        barCode: row.barCode,
        imageUrl: row.imageUrl,
        productType: row.productType,
        sellingPrice: row.productPrice,
        sellingPriceMask: row.productPrice,
      });
    },
    resetNewProduct(row) {
      row.newProductId = null;
      row.newProductName = '';
      row.newProductCode = '';
      row.newBarCode = '';
      row.newImageUrl = '';
      row.newSearchText = '';
      row.newImeiCode = '';
      row.newProductType = null;
    },
    openImeiModal(row) {
      if (!this.newStoreId) {
        return;
      }
      this.$refs.imeiModal.show({
        rowId: row.id,
        productId: row.newProductId,
        storeId: this.newStoreId,
        currentImei: row.newImeiCode,
      });
    },
    onImeiSelected({ rowId, imeiCode }) {
      const row = this.rows.find((item) => item.id === rowId);
      if (row) {
        row.newImeiCode = imeiCode;
        row.newQuantity = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-exchange-product {
  .section-title {
    font-weight: 600;
    color: #181c32;
    font-size: 0.95rem;
  }
  .add-btn {
    border: 1px solid #e4e6ef;
  }
  .col-head {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #b5b5c3;
    padding: 0 8px 6px;
    & > div {
      padding-left: 8px;
    }
  }
  .dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .dot-old {
    background-color: #1bc5bd;
  }
  .dot-new {
    background-color: #ffa800;
  }

  .pair-card {
    border: 1px solid #e4e6ef;
    border-radius: 10px;
    padding: 10px 12px;
    margin-bottom: 12px;
    background-color: #fff;
    &.invalid {
      border-color: #ffe2b8;
      background-color: #fffaf2;
    }
  }
  .pair-head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }
  .index-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #f3f6f9;
    color: #7e8299;
    font-size: 0.75rem;
    font-weight: 700;
  }
  .type-badge,
  .status-badge {
    font-size: 0.7rem;
    font-weight: 600;
  }
  .delete-icon {
    cursor: pointer;
    &:hover {
      color: #f64e60 !important;
    }
  }

  .pair-body {
    display: flex;
    align-items: stretch;
    gap: 8px;
  }
  .prod-card {
    flex: 1;
    border: 1px solid #ebedf3;
    border-left-width: 3px;
    border-radius: 8px;
    padding: 10px;
    min-width: 0;
  }
  .prod-old {
    border-left-color: #1bc5bd;
  }
  .prod-new {
    border-left-color: #ffa800;
  }
  .pair-arrow {
    display: flex;
    align-items: center;
    color: #b5b5c3;
  }

  .prod-info {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    position: relative;
  }
  .prod-text {
    min-width: 0;
  }
  .prod-code {
    font-size: 0.8rem;
    font-weight: 600;
    color: #3699ff;
  }
  .prod-bar {
    font-size: 0.72rem;
    font-style: italic;
    color: #b5b5c3;
    margin-left: 4px;
  }
  .prod-name {
    margin: 2px 0 4px;
    font-weight: 600;
    font-size: 0.82rem;
    color: #181c32;
    line-height: 1.25;
  }
  .imei-tag {
    font-size: 0.7rem;
    border: 1px solid #e4e6ef;
    color: #7e8299;
  }
  .reset-new {
    margin-left: auto;
    cursor: pointer;
    &:hover {
      color: #f64e60 !important;
    }
  }

  .prod-inputs {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    align-items: flex-end;
  }
  .input-block {
    flex: 1;
    label {
      display: block;
      font-size: 0.68rem;
      font-weight: 700;
      letter-spacing: 0.03em;
      color: #b5b5c3;
      margin-bottom: 2px;
    }
  }
  .choose-imei-btn {
    height: calc(1.35em + 1.1rem + 2px);
    background-color: #212529;
    border-color: #212529;
    color: #fff;
    text-align: left;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.chosen {
      background-color: #1bc5bd;
      border-color: #1bc5bd;
    }
  }
  .quick-pick {
    margin-top: 8px;
    text-align: center;
    color: #3699ff;
    font-size: 0.8rem;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .empty-box {
    text-align: center;
    color: #b5b5c3;
    padding: 28px;
    border: 1px dashed #e4e6ef;
    border-radius: 10px;
  }

  @media (max-width: 991.98px) {
    .pair-body {
      flex-direction: column;
    }
    .pair-arrow {
      justify-content: center;
      transform: rotate(90deg);
    }
  }
}
</style>
